import React from 'react';
import {useSelector} from 'react-redux';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import {QuestionnaireElementInteraction} from '../../../../../incase-domain/proptypes/runfile';
import {activeMobileQuestionSelector} from '../../../../../store/selectors/presentation.selectors';
import {getBorderStyle} from '../../../../../util/style.utils';
import ConfirmButton from './ConfirmButton';
import QuestionCounter from './QuestionCounter';
import QuestionTitle from './QuestionTitle';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';
import DisplayLiveResults from '../liveReport/DisplayLiveResults';
import {usePresentationMode} from '../../../../../hooks/usePresentationMode';

interface QuestionLayoutProps {
    element: IElementQuestionnaire;
    elementInteractions: QuestionnaireElementInteraction;
    device?: DeviceType;
    showConfirmButton?: boolean;
    onConfirm?: () => void;
    confirmDisabled?: boolean;
    children?: React.ReactNode;
    hideResults?: boolean;
    hideCounter?: boolean;
}

function QuestionLayout(props: QuestionLayoutProps): JSX.Element {
    const {
        element,
        elementInteractions,
        device = DeviceType.DESKTOP,
        showConfirmButton,
        onConfirm = () => undefined,
        confirmDisabled = false,
        children,
        hideResults = false,
        hideCounter = false,
    } = props;

    const activeMobileQuestion = useSelector(activeMobileQuestionSelector);

    const {questionBackgroundColor, questionBackgroundBorderRadius} = element;
    const {isPresenter} = usePresentationMode();

    return (
        <div
            className={`c-questionLayout ${device === DeviceType.MOBILE && 'c-questionLayout--mobile'} ${
                activeMobileQuestion === element.id && 'is-active'
            }  ${'answered' in elementInteractions && elementInteractions.answered && 'is-answered'}`}
            style={{
                backgroundColor: questionBackgroundColor,
                borderRadius: getBorderStyle(questionBackgroundBorderRadius),
            }}
        >
            {element.isDebatable && <div className="c-questionLayout__ribbon">debate</div>}
            <div className="c-questionLayout__header">
                <QuestionTitle element={element} device={device} />
                {!hideCounter && <QuestionCounter element={element} elementInteractions={elementInteractions} />}
            </div>
            <div className="c-questionLayout__body">{children}</div>
            <div className="c-questionLayout__footer">
                <>
                    {showConfirmButton && (
                        <ConfirmButton
                            element={element}
                            onConfirm={onConfirm}
                            disabled={confirmDisabled}
                            answered={elementInteractions.answered}
                            device={device}
                            disablePointerEvents={elementInteractions.answered}
                        />
                    )}
                    {(isPresenter || element?.showResults) && !hideResults && <DisplayLiveResults element={element} />}
                </>
            </div>
        </div>
    );
}

export default QuestionLayout;
